window.isScriptLoaded = false;
// var vehicleSelectionWrapper = document.querySelector('.desktop-banner-vehicle-selector');
// if (vehicleSelectionWrapper != null) {
//   if (window.innerWidth > 767) {
//     vehicleSelectionWrapper.addEventListener('mouseover', function(e) {
//       if (!window.isScriptLoaded) {
//         vehicleSelectionWrapper.querySelector('#easysearch-holder').click();
//         window.isScriptLoaded = true;
//       }
//     }) 
//   } else {
//     setTimeout(function() {
//       document.querySelector('#hpVehicleContainer').click();
//     }, 2000)
//   }
// }